import { render } from "./S171024.vue?vue&type=template&id=8ab32090"
const script = {}
script.render = render

export default script